@if (anchor) {
  <a [id]="anchor"></a>
}
@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}

<figure kb-overlay-figure
  [heading]="attributes.button.attributes.label"
  [link]="{ href: attributes.button.attributes.url, target: attributes.button.attributes.target }"
  [appEditorId]="attributes.medium.editorIds?.src"
>
  <kb-picture
    [picture]="imageToPicture(attributes.medium.attributes, aspectRatio).sources"
    [appOgImage]="attributes.medium.attributes"
    [alt]="attributes.medium.attributes.alt"
    [variants]="variants"
    [rootColumns]="attributes.numColumns"
  ></kb-picture>
</figure>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
